import { bannerMsgR2 } from 'services/graphql/fragments/BannerMessagesR2';
import {
  card,
  creditScore,
  institution,
  money,
  savingsTracker,
} from 'services/graphql/fragments/Fragments';
import { VXLResponsiveTextFragment } from 'services/graphql/fragments/VxlStyles';
import { gql } from 'urql';

const gqlQuery = gql`
  query GetAccountR2($id: ID!) {
    accountR2(id: $id) {
      id
      type
      product
      status
      institution {
        ...institution
      }
      name
      nickname
      iconUrl
      accountNumber
      accountNumberLast4
      bannerMessagesR2 {
        ...bannerMsgR2
      }
      details {
        ... on ChargeCardAccountDetailPaymentGroup {
          creditBuildingItems {
            key
            description
            title
            value
            itemDetail {
              title
              descriptionHtml
              description
              articleLink {
                __typename
                copy
                articleId
                article {
                  id
                  title
                }
              }
            }
            articleLink {
              __typename
              copy
              articleId
              article {
                id
                title
              }
            }
            __typename
          }
        }
        title
        items {
          key
          description
          title
          value
          itemDetail {
            title
            descriptionHtml
            description
            articleLink {
              __typename
              copy
              articleId
              article {
                id
                title
              }
            }
          }
          articleLink {
            __typename
            copy
            articleId
            article {
              id
              title
            }
          }
          __typename
        }
        __typename
      }

      ... on InternalSavingsAccount {
        apy
        yearToDateInterest {
          ...money
        }
        isDefaultAccount
        fullAccountNumber
        routingNumber
        totalBalance {
          ...money
        }
        availableBalance {
          ...money
        }
        savingsTracker {
          ...savingsTracker
        }
      }

      ... on InternalChargeCardAccount {
        id
        type
        canAccessCardService
        ...creditScore
        routingNumber
        isDefaultAccount
        hasVaultShortfall
        totalBalance {
          ...money
        }
        availableBalance {
          ...money
        }
        cards {
          ...card
        }
        isSafePayEnabled
        autoPaymentSettings {
          enabled
        }
        action {
          type
          title
          message
          location
        }
        vaultBalance {
          ...money
        }
        paymentDue {
          dueDate
          amount {
            ...money
          }
        }
        vaultShortFallAmount {
          ...money
        }
        canAddFunds
        canPayCard
        displayBalance {
          title
          amount {
            ...money
          }
        }
      }

      ... on InternalCheckingAccount {
        canAccessCardService
        routingNumber
        isDefaultAccount
        cards {
          ...card
        }
        fullAccountNumber
        totalBalance {
          ...money
        }
        availableBalance {
          ...money
        }
      }

      ... on ExternalPlaidAccount {
        accountNumber
        accountNumberLast4
        routingNumber
        fullAccountNumber
        isCraEnabled
      }

      ... on InternalAdvanceAccount {
        id
        type
        product
        status
        institution {
          ...institution
        }
        name
        nickname
        iconUrl
        accountNumber
        accountNumberLast4
        routingNumber
        isDefaultAccount
        visibility {
          isVisible
          userPreference
        }
        reEligiblityDetail {
          description
          descriptionHtml
          title
        }
        totalBalance {
          ...money
        }
        availableBalance {
          ...money
        }
        displayBalance {
          title
          amount {
            ...money
          }
        }
        description
        advanceStatus
        activeAdvance {
          id
          description
          dateOfAdvance
          dueDate
          amountDue {
            ...money
          }
          details {
            items {
              title
              description
              copy
            }
          }
          detailsV2 {
            items {
              copy
              vxlCopy {
                ...VXLResponsiveTextFragment
              }
              title
              id
              description
              vxlTitle {
                ...VXLResponsiveTextFragment
              }
            }
          }
          payments {
            id
            date
            amount {
              ...money
            }
            title
            description
          }
        }
        agreements {
          id
          title
          documentId
        }
        pastAdvances {
          edges {
            node {
              __typename
              id
              description
              dateOfAdvance
              dueDate
              amount {
                ...money
              }
              fee {
                ...money
              }
              amountDue {
                ...money
              }
              detailsV2 {
                items {
                  copy
                  vxlCopy {
                    ...VXLResponsiveTextFragment
                  }
                  title
                  id
                  description
                  vxlTitle {
                    ...VXLResponsiveTextFragment
                  }
                }
              }
              advancePayments {
                ... on SLTitledListComponent {
                  children {
                    ... on TransactionRowComponent {
                      id
                      primaryDetail {
                        copy
                      }
                      primaryText {
                        copy
                      }
                      secondaryDetail {
                        copy
                      }
                      secondaryText {
                        copy
                      }
                    }
                  }
                  id
                  title {
                    copy
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${creditScore}
  ${card}
  ${institution}
  ${money}
  ${savingsTracker}
  ${bannerMsgR2}
  ${VXLResponsiveTextFragment}
`;

export default gqlQuery;
